<script>
export default {
    props: {
        apiUrl: {
            type: String,
            required: true,
        },
        filters: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            items: [],
            page: 1,
            perPage: 10,
            totalCount: 0,
            isLoading: false,
            debounceTimer: null,
        };
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.isLoading = true;

            this.$store.getters.api
                .get(this.apiUrl, {
                    params: {
                        page: this.page,
                        page_size: this.perPage,
                        ...this.filters,
                    },
                })
                .then((response) => {
                    this.items = response.data.results;
                    this.totalCount = response.data.count;
                })
                .catch((error) => {
                    console.error("Error loading vehicle entries", error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        setPage(page) {
            this.page = page;
            this.loadData();
        },
        setPerPage(perPage) {
            this.perPage = perPage;
        },
        refresh() {
            this.loadData();
        },
    },
    watch: {
        filters: {
            deep: true,
            handler() {
                this.page = 1;

                if (this.debounceTimer) {
                    clearTimeout(this.debounceTimer);
                }

                this.debounceTimer = setTimeout(() => {
                    this.loadData();
                }, 1000);
            },
        },
        perPage() {
            this.page = 1;
            this.loadData();
        },
    },

    render() {
        if (!this.$slots.default) {
            return null;
        }

        return this.$slots.default({
            items: this.items,
            page: this.page,
            perPage: this.perPage,
            totalCount: this.totalCount,
            isLoading: this.isLoading,
            setPage: this.setPage,
            setPerPage: this.setPerPage,
            refresh: this.refresh,
        });
    }
}
</script>